import styled, { css } from 'styled-components';
import Check from '../../../static/check.svg';
import MiniDot from '../../../static/dot.svg';

export const Container = styled.div`
  height: 44px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
`;

export const Dot = styled.div`
  width: 22px;
  height: 22px;
  border: 2px solid #93b8c9;
  box-shadow: 0 2px 4px rgba(147, 184, 201, 0.44);
  border-radius: 50%;
  position: relative;
  z-index: 2;

  ${({ progress, index }) =>
    progress >= index &&
    css`
      background: #fff url(${MiniDot}) no-repeat;
      background-position: center center;
    `};

  transition: background-color 180ms ease-out;

  ${({ check }) =>
    check &&
    css`
      background: #93b8c9 url(${Check}) no-repeat;
      background-position: center center;
    `} &:last-child {
    &:after {
      opacity: 0;
    }
  }
  &:after {
    position: absolute;
    top: 8px;
    left: 20px;
    z-index: 1;
    content: '';
    ${({ steps }) =>
      steps &&
      css`
        width: calc(100vw / ${steps - 1} - 68px);
        max-width: 332.5px;
        height: 2px;
        background: rgba(147, 184, 201, 0.44);
      `};
  }
`;
